import React, { useState, useMemo } from "react";
import "../../pages/projectMaster/projectMaster.scss";
import Avatar from "../../components/common/Avatar";
import Status from "../../components/common/Status";
import Chip from "../../components/common/Chip";
import Spinner from "../../components/common/Spinnner";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import SkeletonProjectGrid from '../common/skeletonProjectGrid'

const ProjectGrid = (props) => {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredResults, count]);

  return (
    <>
  <div className="row project-table-row mb-4rem">
  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
    {loading ? (
      <>
        {Array.from({ length: 25 }).map((_, index) => (
          <SkeletonProjectGrid key={index} />
        ))}
      </>
    ) : currentTableData?.length > 0 ? (
      <div className="card mt-0 project-list-card">
        <div className="card-body">
          <div className="table-responsive project-table-responsive">
            <table className="table table-borderless table-list project-table-list">
              <thead>
                <tr>
                  <th><div>PROJECT</div></th>
                  <th><div>PROJECT REF</div></th>
                  <th><div>PROJECT SEGMENT</div></th>
                  <th><div>DISTRIBUTOR</div></th>
                  <th><div>MAIN CONTRACTOR</div></th>
                  <th><div>MEP CONTRACTOR</div></th>
                  <th><div>PROJECT STATUS</div></th>
                  <th><div>COUNTRY</div></th>
                  <th><div>ACTIONS</div></th>
                </tr>
              </thead>

              <tbody>
                {currentTableData.map((item, index) => (
                  <tr key={item.id || index}>
                    <td
                      onClick={
                        menuRights?.canView
                          ? () => handleView(item)
                          : undefined
                      }
                      className={
                        menuRights?.canView
                          ? "clickable-cell"
                          : ""
                      }
                    >
                      <div className="project-cell">
                        <Avatar preName={item.projectName} />
                        <h4>{item.projectName}</h4>
                      </div>
                    </td>

                    <td>
                      <h5>{item.projectCode || "-"}</h5>
                    </td>

                    <td>
                      <h5>{item.ProjectSegment || "-"}</h5>
                    </td>

                    <td>
                      <h5>{item.Distributor || "-"}</h5>
                    </td>

                    <td>
                      <h5>{item.MainCustomer || "-"}</h5>
                    </td>

                    <td>
                      <h5>{item.MEPCustomer || "-"}</h5>
                    </td>

                    <td>
                      <span className={`project-status ${item?.ProjectStatus?.toLowerCase().replace(/\s+/g, "-")}`}>
                        <Status />
                        {item.ProjectStatus}
                      </span>
                    </td>

                    <td>
                      <h5>{item.Country || "-"}</h5>
                    </td>

                    <td>
                      {(menuRights?.canEdit ||
                        menuRights?.canDelete) && (
                        <div className="dropdown dropleft action-menu">
                          <span
                            className="action-icon"
                            data-toggle="dropdown"
                          >
                            <i className="fas fa-ellipsis-v"></i>
                          </span>

                          <div className="dropdown-menu p-0">
                            <ul>
                              {menuRights?.canEdit && (
                                <li>
                                  <span
                                    onClick={() => handleEdit(item)}
                                  >
                                    <i className="far fa-edit mr-1"></i>
                                    Edit
                                  </span>
                                </li>
                              )}

                              {menuRights?.canDelete && (
                                <li>
                                  <span
                                    onClick={() => handleDelete(item)}
                                  >
                                    <i className="far fa-trash-alt mr-1"></i>
                                    Delete
                                  </span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ) : (
      <NotFound />
    )}
  </div>
</div>
      {currentTableData.length > 0 && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default ProjectGrid;
